/**
 * Display + helpers for AI Usage Credit packs (aligned with server paymentPlanConfig).
 */

export function formatPlanInr(amountInRupees) {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(Number(amountInRupees) || 0);
}

export function formatPlanCredits(tokenCredits) {
  return new Intl.NumberFormat("en-IN").format(Number(tokenCredits) || 0);
}

export function planCreditsPerRupee(plan) {
  const rupees = Number(plan?.amountInRupees);
  const tokens = Number(plan?.tokenCredits ?? plan?.creditTokens);
  if (!rupees || !tokens) return 0;
  return tokens / rupees;
}

/** Plan with the most total credits (for "Best value" on the top pack). */
export function getBestValuePlanName(plans) {
  if (!plans?.length) return "Pro Plan";
  let best = plans[0];
  let bestTokens = Number(best.tokenCredits ?? best.creditTokens) || 0;
  for (const p of plans) {
    const t = Number(p.tokenCredits ?? p.creditTokens) || 0;
    if (t > bestTokens) {
      bestTokens = t;
      best = p;
    }
  }
  return best.name;
}

export function getPopularPlanName(plans) {
  const basic = plans?.find((p) => p.name === "Basic Plan");
  return basic?.name || plans?.[Math.floor((plans?.length || 1) / 2) - 1]?.name;
}
